// src/App.jsx (refactorizado)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Home from './features/Home';
import Login from './features/auth/Login';
import ChangePassword from './features/auth/ChangePassword';
import PeopleModule from './features/people/PeopleModule';
import ErrorBoundary from './components/ErrorBoundary';
import ToolsModule from './features/tools/ToolsModule';
import WorksModule from './features/works/WorksModule';
import InspectionsModule from './features/inspections/InspectionsModule';
import TrainingsModule from './features/trainings/TrainingsModule';
import AlertsModule from './features/alerts/AlertsModule';
import AssistantChat from './features/assistant/AssistantChat';
import { AssistantChatProvider } from './features/assistant/AssistantChatContext';

// El asistente de IA es facturable: en prod se compila con REACT_APP_ASSISTANT_ENABLED
// distinto de 'true' y la ruta queda bloqueada (redirige a Home) hasta el OK del cliente.
const ASSISTANT_ENABLED = process.env.REACT_APP_ASSISTANT_ENABLED === 'true';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </ErrorBoundary>
  );
}

// Componente de enrutamiento con verificación de autenticación
function AppRouter() {
  const { isAuthenticated, loading } = useAuth();

  // Mostrar un indicador de carga mientras verificamos la autenticación
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  // Redirigir a login si no está autenticado
  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  // Si está autenticado, mostrar la aplicación con layout
  return (
    <Router>
      <AssistantChatProvider>
        <Layout>
          <ErrorBoundary>
            <Routes>
            <Route path="/" element={<Home />} />
            {/* Módulo de personas - usando error boundary específico */}
            <Route path="/people/*" element={
              <ErrorBoundary>
                <PeopleModule />
              </ErrorBoundary>
            } />
            {/* Módulo de obras */}
            <Route path="/works/*" element={
              <ErrorBoundary>
                <WorksModule />
              </ErrorBoundary>
            } />
            {/* Módulo de equipos */}
            <Route path="/tools/*" element={
              <ErrorBoundary>
                <ToolsModule />
              </ErrorBoundary>
            } />
            {/* Módulo de inspecciones */}
            <Route path="/inspections/*" element={
              <ErrorBoundary>
                <InspectionsModule  />
              </ErrorBoundary>
            } />
            {/* Módulo de capacitaciones */}
            <Route path="/trainings/*" element={
              <ErrorBoundary>
                <TrainingsModule />
              </ErrorBoundary>
            } />
            {/* Módulo de alertas */}
            <Route path="/alerts/*" element={
              <ErrorBoundary>
                <AlertsModule />
              </ErrorBoundary>
            } />
            {/* Asistente de IA (facturable: bloqueado en prod hasta OK del cliente) */}
            <Route path="/asistente" element={
              ASSISTANT_ENABLED ? (
                <ErrorBoundary>
                  <AssistantChat />
                </ErrorBoundary>
              ) : (
                <Navigate to="/" replace />
              )
            } />
            {/* Perfil */}
            <Route path="/cambiar-password" element={<ChangePassword />} />
            {/* Redirecciones */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </Layout>
      </AssistantChatProvider>
    </Router>
  );
}

export default App;